import { borderRadius, color, fontFamily, fontSize, space } from '@core-ds/primitives';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'prop... Remove this comment to see the full error message
import { string } from 'prop-types';
import * as React from 'react';
import styled from 'styled-components';

const Container = styled.div`
   border-radius: ${borderRadius.sm};
   margin: ${space[1]} 0;
   padding: 0 ${space[1]};
   line-height: 17px;
   min-height: 17px;
   color: ${color.gray[800]};
   background-color: ${color.gray[400]};
   transition: background-color 0.1s;
   font-family: ${fontFamily.monoSystem};
   font-weight: bold;
   font-size: ${fontSize.sm};
   display: flex;
   align-items: center;

   :hover {
      background-color: ${color.white};
   }
`;

// @ts-expect-error ts-migrate(7031) FIXME: Binding element 'isoCode' implicitly has an 'any' ... Remove this comment to see the full error message
const LanguageButton = ({ isoCode }) => (
   <Container id="js-iso-language-dropdown-button">{isoCode}</Container>
);

LanguageButton.propTypes = {
   isoCode: string.isRequired,
};

export default LanguageButton;
